import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";

export default function ConfirmDisableModal({
    open,
    row,
    modeLabel = "ce mode",
    onClose,
    onConfirm,
}: {
    open: boolean;
    row?: any;
    modeLabel?: string;
    onClose: () => void;
    onConfirm: (row: any) => void;
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            PaperProps={{
                sx: {
                    backgroundColor: "#212B36",
                    borderRadius: 3,
                    py: 3,
                    color: "#FFF",
                },
            }}
        >
            <DialogTitle sx={{ fontWeight: 600, fontSize: 18, pb: 0 }}>
                Are you sure?
            </DialogTitle>

            <DialogContent sx={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>
                This action will disable the current reccord.
            </DialogContent>

            <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        textTransform: "none",
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={() => {
                        onConfirm(row);
                    }}
                    sx={{
                        background: "#EF5350",
                        color: "#FFF",
                        textTransform: "none",
                        boxShadow: "0 2px 4px rgba(239,83,80,0.3)",
                        transition: "all 0.25s ease",
                        "&:hover": {
                            background: "#E57373",
                            boxShadow: "0 4px 10px rgba(239,83,80,0.35)",
                        },
                    }}
                >
                    Disable
                </Button>
            </DialogActions>
        </Dialog>
    );
}
